import React, { useEffect, useState ,useRef} from "react";
import "./AddService.css";
//import axios from "axios";
import { useNavigate } from "react-router-dom";
import { getAllServices } from "../../../services/roleServiceMapService";
import { flattenServices, getServiceNameMap, formatServiceName, } from "../../../utils/servicesUtils";
const AddService = () => {
  const navigate = useNavigate();
  const [services, setServices] = useState([]);

  const effectRan = useRef(false);
  // Fetch data on mount
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const data = await getAllServices();
        setServices(data);
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };
if(!effectRan.current)
{
fetchServices();
}
return ()=>{
  effectRan.current =true;
}
    
  }, []);

  const handleAddService = () => {
    navigate("/serviceMaster");
  };

  const handleEdit = (id) => {
    navigate(`/editService/${id}`);
  };


  // Helper to flatten parent-child services


  // const getFlattenedServices = () => {
  //   let result = [];
  //   services.forEach((service) => {
  //     result.push({
  //       ...service,
  //       parentId: null,
  //     });
  //     if (service.children && service.children.length > 0) {
  //       service.children.forEach((child) => {
  //         result.push({
  //           ...child,
  //           parentId: service.serviceId,
  //         });
  //       });
  //     }
  //   });
  //   result.sort((a, b) => a.serviceId - b.serviceId);
  //   return result;
  // };


  // Create map of serviceId -> serviceName
  // const serviceNameMap = {};
  // services.forEach((service) => {
  //   serviceNameMap[service.serviceId] = service.serviceName;
  //   if (service.children && service.children.length > 0) {
  //     service.children.forEach((child) => {
  //       serviceNameMap[child.serviceId] = child.serviceName;
  //     });
  //   }
  // });


  // const flattenedServices = getFlattenedServices();

  // const formatServiceName = (name) => {
  //   return name.replace(/([a-z])([A-Z])/g, "$1 $2");
  // };

  const flattenedServices = flattenServices(services);
  const serviceNameMap = getServiceNameMap(services);
  return (


    <div className="main-service">
      <h2>Service Master</h2>
      <div className="service">

        <div>
          <button className="add-btn-service" onClick={handleAddService}>Add</button>
          <table className="service-table">
            <thead>
              <tr>
                {/* <th>S.No</th> */}
                <th>Service Id</th>
                <th>Service Name</th>
                <th>Parent Id</th>
                <th>Service Link</th>
                <th>Display Order</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {flattenedServices.map((service, index) => (
                <tr key={service.serviceId}>
                  {/* <td>{index + 1}</td> */}
                  <td>{service.serviceId}</td>
                  <td style={{ textAlign: "left" }}>{formatServiceName(service.serviceName)}</td>
                  <td>{service.parentId ? serviceNameMap[service.parentId] : 0}</td>
                  <td style={{ textAlign: "left" }}>{service.serviceLink}</td>
                  <td>{service.displayOrder}</td>
                  <td >
                    <div >
                      <button className="edit-btn-service" onClick={() => handleEdit(service.serviceId)}>Edit</button>
                    </div>

                  </td>
                </tr>
              ))}
              {flattenedServices.length === 0 && (
                <tr>
                  <td colSpan="7" style={{ textAlign: "center" }}>
                    No services found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AddService;
